import React, {Component} from 'react';
import _ from 'lodash';
import { Alert } from 'componentLibrary';
import {Header, Form, Radio} from 'semantic-ui-react';
import {RadioField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';

export class EmailList extends Component {
    render() {
        const {emails, notificationEmail} = this.props;
        const radioOptionsData = _.map(emails, (userEmailObj)=>{
            return {"label": userEmailObj.emailAdr, "value": userEmailObj.emailAdr};
        });
        return (
            <>
              <Header as="h3">Email for Notifications</Header>
              <Alert info header="Email Use">
                <p>
                    All FEMA GO notifications will be sent to the selected email below.
                    The list of emails come from your Login.gov account.  If the email
                    you wish to use for FEMA GO notifications is not on the list, go to
                    Login.gov to add it.  The next time you login to FEMA GO, this
                    email will be available for you to select.
                </p>
              </Alert>
              <RadioField key="profile-notificationEmail" name="emailAdr" value={notificationEmail} options={radioOptionsData} 
                            handleChange={this.props.handleChange}
              />
            </>
        )
    }
}

export default EmailList;